export default __webpack_public_path__ + "img/71738db3e6fbf39f5af5e11f213d7eb6.png";